<div class="upload-examinee-wrapper content-wrapper">
  <mat-card>
    <mat-card-content>
      <div class="head-container">
        <div class="pageTitle">
          <h1>{{'items.multipleItems.heading' | translate}}</h1>
          <!-- <div (mouseover)="onTrainingIcon(videoAssetGroups.ItemUpload)">
            <img class="trainingIcon" src="../../../assets/favicon/video.png">
          </div>

          <div class="popupHover">
            <ng-container *ngIf="isHidden">
              <div class="hideshow">
                <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
              </div>
            </ng-container>
          </div> -->
        </div>
        <div class="bread-crumb">
          <div class="breadcrumb-container">
            <a (click)="goToPrevious()" class="link-active">{{'items.multipleItems.nav1' | translate}}</a> /
            <span class="nav-link">{{'items.multipleItems.nav2' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="main-content-wrapper item-bank-details-container">
        <div class="content-wrapper">
          <div class="container-fluid">
            <div class="row ">
              <div class="col-md-12">
                <div class="download-upload-wrapper">
                  <div class="spacer"></div>
                  <div class="download">
                    <button class="btn-primary-link" (click)="download()" mat-flat-button>
                      <span>{{'items.multipleItems.btnDownload' | translate}}</span>
                    </button>

                  </div>
                  <div class="upload">
                    <form [formGroup]="uploadFileForm" enctype="multipart/form-data">
                      <button class="btn-warn" (click)="uploadExcelFile()" mat-flat-button>
                        <input type="file" #fileUpload multiple="multiple" formControlName="file" />
                        <span>{{'items.multipleItems.btnUpload' | translate}}</span>
                      </button>
                    </form>
                    <div *ngIf="isValidFileName" class="alert alert-danger">
                      <div *ngIf="isValidFileName">{{'items.multipleItems.errorMsgUpload' | translate}}</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <!--  -->
            <div class="row ">
              <div class="col-12">

                <ng-container *ngIf="dataSource && !emptyMsg && !isError then showTable else hideTable"></ng-container>
                <ng-template #showTable>
                  <div *ngIf="uploadSuccess == false">
                    <div class="upload-status-false">
                      <p>{{ uploadResponse?.uploadStatus | titlecase }}</p>
                    </div>
                    <p>{{'items.multipleItems.showTable.labelTotalRecords' | translate}}:
                      {{uploadResponse?.totalNoOfRecords}}</p>
                    <p>{{'items.multipleItems.showTable.labelTotalRecordsImported' | translate}}:
                      {{uploadResponse?.totalNoOfSuccessfullRecords}}
                    </p>
                  </div>
                  <div *ngIf="uploadSuccess== true">
                    <div>
                      <p class="upload-status">{{ uploadResponse?.uploadStatus | titlecase }}</p>

                    </div>
                    <p>{{'items.multipleItems.showTable.labelTotalRecords' | translate}}: {{uploadResponse?.totalNoOfRecords}}</p>
                    <p>{{'items.multipleItems.showTable.labelTotalRecordsImported' | translate}}: {{uploadResponse?.totalNoOfSuccessfullRecords}}
                    </p>
                  </div>
                  <!-- <div class="empty-msg" *ngIf="uploadSuccess== false">
                    <p>{{'items.multipleItems.showTable.errorReport' | translate}}</p>
                  </div>
                  <div class="empty-msg" *ngIf="uploadEmpty== true && uploadSuccess== false">
                    {{'items.multipleItems.showTable.uploadEmptyMsg' | translate}}
                  </div> -->


                  <div *ngIf="!isNoError" class="report-table">
                    <div class=" table-container">
                      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

                        <ng-container matColumnDef="indexNo">
                          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="width-20">{{'items.multipleItems.showTable.column1' | translate}}</th>
                          <td mat-cell *matCellDef="let row">
                            {{row?.rowNumber-1}}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="rowNo">
                          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="width-20">{{'items.multipleItems.showTable.column2' | translate}}</th>
                          <td mat-cell *matCellDef="let row">
                            {{row?.rowNumber}}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="errorComment">
                          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true" class="width-60">{{'items.multipleItems.showTable.column3' | translate}}</th>
                          <td mat-cell *matCellDef="let row">
                            <ul class="errMsg-wrapper">
                              <li *ngFor="let errMsg of row?.message?.split('\r\n') let i=index" [class.empty]='errMsg.length < 1 || errMsg == "  "'>
                                <span>{{ errMsg }}</span>
                              </li>
                            </ul>
                          </td>
                        </ng-container>


                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-data">
                        </tr>
                      </table>
                    </div>
                    <div class="examinee-paginator">
                      <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
                    </div>
                  </div>

                </ng-template>
              </div>

              <ng-template #hideTable>
                <div *ngIf="uploadSuccess== false">
                  <div class="upload-status-false">
                    <p>{{ uploadResponse?.uploadStatus | titlecase }}</p>
                  </div>
                </div>
                <div class="upload-status-msg">
                  <p>{{emptyMsg}}</p>
                </div>
              </ng-template>

            </div>
            <!--  -->
          </div>

        </div>

      </div>
    </mat-card-content>
  </mat-card>
</div>
